import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/system';
import { Box } from '@mui/material';

import EnlargeOnHover from './animation/HoverAnimation';

const StyledChip = styled(Chip)({
  color: 'customText.dark',
  fontWeight: '600',
  padding: '1.1rem',
});

export default function SkillCard(props) {
  const skillDesc = props.skillDescription;
  const skillMediaPath = props.skillMediaPath;
  const skillDescItem = skillDesc.map((desc, index) => {
    return (
      <Grid item xs key={index}>
        <EnlargeOnHover
          children={
            <StyledChip
              sx={{
                typography: {
                  fontWeight: 'bold',
                  color: 'customText.dark',
                  xl: {
                    fontSize: '1.05rem'
                  }
                }
              }}
              label={desc}
            >
            </StyledChip>
          }
        ></EnlargeOnHover>
      </Grid>
    );
  });
  return (
    <Card
      sx={{
        bgcolor: "white",
        boxShadow: 3
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <CardMedia
          component="img"
          height="194"
          image={skillMediaPath}
          alt="Paella dish"
        />
        <CardHeader
          title={props.skillName}
          titleTypographyProps={{
            component: "span",
            fontWeight: "bold",
            sx: {
              typography: {
                xs: {
                  fontSize: '1.4rem'
                },
                sm: {
                  fontSize: '1.7rem'
                },
                xl: {
                  fontSize: '1.6rem'
                }
              }
            }
          }}
          sx={{
            position: 'absolute',
            top: '65%',
            left: '1%',
            color: 'white',
          }}
        >
        </CardHeader>
      </Box>
      <CardContent>
        <Grid
          container
          spacing={1}
          padding={1}
        >
          {skillDescItem}
        </Grid>
      </CardContent>
    </Card>
  );
}